import { Delete } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { ESRThunkDispatch } from "../../../actions/form";
import { updateThread } from "../../../actions/util";
import { Thread } from "../../../types/data";
import { useCurrentUser } from "../../../hooks/useCurrentUser";

type Props = {
	thread: Thread;
	email: string;
};

export function UserChip({ thread, email }: Props) {
	const { esrId = "" } = useParams();

	const dispatch = useDispatch<ESRThunkDispatch>();

	const removeRecipient = useCallback(() => {
		dispatch(
			updateThread(esrId, thread.id, {
				recipients: thread.receiver_ids.filter(
					(curEmail) => curEmail !== email,
				),
			}),
		);
	}, [esrId, thread, email]);

	const [user, setUser] = useCurrentUser();

	return (
		<>
			<Chip
				key={email}
				label={email}
				deleteIcon={user?.email === thread?.creator_id ? <Delete /> : <></>}
				onDelete={removeRecipient}
				sx={{
					"& .MuiChip-deleteIcon": {
						color: "red",
						"&:hover": {
							color: "darkred",
						},
					},
				}}
			/>
		</>
	);
}
